module.exports = __webpack_public_path__ + "media/images/pic/testimonials/kuba-f1865916a27e0d370bfd3e9dec52e7f1.webp";